import { jsx, jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { Color } from "../../common/enums/colors.js";
import './lifetime.overlay.css';function LifetimeOverlay({
  backgroundColor = Color.DEFAULT_RED,
  currentAmount = 0
}) {
  const contentRef = useRef(null);
  const [currentAmountLength, setCurrenAmountLength] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (contentRef.current) {
        contentRef.current.className = "ribbon active";
      }
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    let number = currentAmount;
    let numberString = number.toString().replace(".", "");
    let lengthOfDigits = numberString.length;
    setCurrenAmountLength(lengthOfDigits);
    console.log(lengthOfDigits);
  }, [currentAmount]);
  const getFontSize = (length) => {
    if (length <= 7) return "5.3rem";
    if (length === 8) return "4.8rem";
    if (length === 9) return "4.3rem";
    if (length >= 10) return "4rem";
    return "";
  };
  const fontSize = getFontSize(currentAmountLength);
  console.log(fontSize);
  const fontStyles = {
    fontSize
  };
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });
  return /* @__PURE__ */ jsx("div", { className: "lifetime-overlay", children: /* @__PURE__ */ jsxs("div", { className: "ribbon", ref: contentRef, children: [
    /* @__PURE__ */ jsx("div", { className: `ribbon-1 ${backgroundColor}`, children: /* @__PURE__ */ jsx("span", { className: "inner", children: /* @__PURE__ */ jsx("span", { className: "fadeLeft", children: "Lifetime Fundraising" }) }) }),
    /* @__PURE__ */ jsx("div", { className: `ribbon-2 ${backgroundColor}`, children: /* @__PURE__ */ jsx("span", { className: "inner", children: /* @__PURE__ */ jsx("span", { className: "fadeRight", style: fontStyles, children: formatter.format(currentAmount).replace(".00", "") }) }) }),
    /* @__PURE__ */ jsx("div", { className: `ribbon-3 ${backgroundColor}`, children: /* @__PURE__ */ jsx("span", { className: "inner", children: /* @__PURE__ */ jsx("span", { className: "fadeLeft", children: "for St. Jude" }) }) })
  ] }) });
}
const LifetimeOverlayBackgroundColors = [
  Color.DEFAULT_RED,
  Color.LIGHT_PURPLE,
  Color.DARK_PURPLE,
  Color.LIGHT_BLUE,
  Color.DARK_BLUE,
  Color.LIGHT_AQUA,
  Color.LIGHT_GREEN,
  Color.DARK_GREEN,
  Color.LIGHT_YELLOW,
  Color.DARK_YELLOW
];
function toLifetimeOverlayBackgroundColor(color) {
  if (!color) return Color.DEFAULT_RED;
  return LifetimeOverlayBackgroundColors.find((c) => c === color) ?? Color.DEFAULT_RED;
}
function getLifetimeConfigFromURL(url) {
  const config = new URLSearchParams(url.search);
  const backgroundColor = toLifetimeOverlayBackgroundColor(
    config.get("bgColor")
  );
  return {
    backgroundColor
  };
}
export {
  LifetimeOverlay,
  LifetimeOverlayBackgroundColors,
  getLifetimeConfigFromURL,
  toLifetimeOverlayBackgroundColor
};
//# sourceMappingURL=lifetime.overlay.js.map
